import React from 'react';
import { Redirect, RouteComponentProps, useHistory } from 'react-router';
import { DailyPauseCelebrationModal } from '../components/DailyPauseCelebrationModal';

type Props = RouteComponentProps<{}, {}, { uuid?: string } | undefined>;

export const DailyPauseCelebration: React.FC<Props> = ({ location }) => {
    const history = useHistory();

    const uuid = location.state?.uuid;

    if (!uuid) {
        return <Redirect to="/dashboard" />;
    }

    return (
        <DailyPauseCelebrationModal
            show={true}
            contentUuid={uuid}
            onDismiss={() => {
                history.push('/dashboard');
            }}
        />
    );
};
